import React from 'react';
import { Badge, Box, Text, Tooltip, Group } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import type { EntityRegistryEntry, ColumnOptions } from '../types';
import { getSetWarnings } from '../../validation/setValidation';

export const setConfig: EntityRegistryEntry = {
    hideIdInStandard: true,
    fetchAttributes: ['Id', 'DisplayName', 'EntityType', 'FilterScope', 'IsSystem', 'Type', 'Description'],
    tableFlags: { showSystemFilter: true },
    listColumns: ({ isStandard }: ColumnOptions) => {
        const columns = [
            {
                key: 'filterscope',
                label: 'Filter Scope',
                sortable: true,
                render: (entity: any) => entity.FilterScope || 'N/A'
            },
            {
                key: 'type',
                label: 'Type',
                sortable: true,
                render: (entity: any) => {
                    const type = entity.Type || '';
                    if (!type) return 'N/A';
                    const isManual = type === 'Manual';
                    const isEnumerated = type === 'Enumerated';
                    if (isManual || isEnumerated) {
                        return (
                            <Badge size="sm" variant="light" color={isManual ? 'green' : 'blue'}>
                                {type}
                            </Badge>
                        );
                    }
                    return (
                        <Group gap={4} align="center">
                            <Text size="sm">{type}</Text>
                            <Tooltip label={`Invalid Type: "${type}". Must be "Manual" or "Enumerated"`}>
                                <Box component="span" display="inline-flex">
                                    <IconAlertCircle size={18} color="var(--mantine-color-red-6)" />
                                </Box>
                            </Tooltip>
                        </Group>
                    );
                }
            },
            {
                key: 'description',
                label: 'Description',
                sortable: true,
                render: (entity: any) => entity.Description || ''
            }
        ];

        if (!isStandard) {
            columns.splice(2, 0, {
                key: 'issystem',
                label: 'Is System',
                sortable: true,
                render: (entity: any) => {
                    const raw = (entity as any).IsSystem;
                    const isSystem = typeof raw === 'boolean'
                        ? raw
                        : (typeof raw === 'string'
                            ? raw.toLowerCase() === 'true'
                            : !!raw);
                    return (
                        <Badge
                            variant="outline"
                            size="sm"
                            color={isSystem ? 'blue' : 'gray'}
                        >
                            {isSystem ? 'Yes' : 'No'}
                        </Badge>
                    );
                }
            });
        }

        return columns;
    },
    getWarnings: (data) => getSetWarnings(data),
};
